import {
  Action,
  ActionType,
  AttendanceStatusResponse,
} from "models/dashboard/attendanceStatus";
import createReducer from "../../createReducer";

export interface AttendanceStatusReducerType {
  loading: boolean;
  error?: string;
  attendanceStatusResponse?: AttendanceStatusResponse;
}

const defaultState: AttendanceStatusReducerType = {
  loading: false,
  error: undefined,
  attendanceStatusResponse: undefined,
};

export const getAttendanceStatusReducer =
  createReducer<AttendanceStatusReducerType>(defaultState, {
    [ActionType.GET_ATTENDANCE_STATUS_CHART](
      state: AttendanceStatusReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_ATTENDANCE_STATUS_CHART_ERROR](
      state: AttendanceStatusReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_ATTENDANCE_STATUS_CHART_SUCCESS](
      state: AttendanceStatusReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        attendanceStatusResponse: action.payload,
      };
    },
  });
